import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { companySettingsService } from '@api/services/services';
import { CompanySettingsDto } from '@api/models/settings/CompanySettingsDto';

type State = BaseType<CompanySettingsDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    smtpPort: undefined,
    smtpHost: '',
    smtpUsername: '',
    smtpPassword: '',
    earliestEntryTimeTolerance: null,
    archiveInvalidInvitationsAfter: null,
    defaultAddWorkerToInvitation: true,
    banner: '',
    bannerUrl: '',
    emailLogoHeight: 120,
    primaryColor: '',
    secondaryColor: '',
    defaultLanguage: '',
    testLanguages: [],
    smsBillingConsentHistory: [],
    unresolvedInvitationReminder: null,
  },
};

export const companySettingsSlice = baseSlice({
  name: 'companySettings',
  initialState,
});

export const selectCompanySettingsState = (state: RootState) => state.companySettings.state;
export const selectCompanySettings = (state: RootState) => state.companySettings.data;
export const selectSmsBillingConsent = (state: RootState) => state.companySettings.data.smsBillingConsent;
export const companySettingsActions = companySettingsSlice.actions;

export const getCompanySettings = () => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return companySettingsService.getSettings();
  };

  getItem({
    dispatch,
    actions: companySettingsActions,
    getData: handleGetData,
  });
};
